import React, { Fragment } from 'react';

// eslint-disable-next-line no-restricted-imports
import { forTemplate } from 'common/lib/util/i18n';
const format = forTemplate('error');

// eslint-disable-next-line no-restricted-imports
import { HeaderSkeleton } from 'common/components/HeaderSkeleton';
import { CaughtError, ErrorDetails } from '../ErrorBoundary';

export const GlobalErrorHandler = ({
  caughtError,
}: {
  caughtError: CaughtError;
}) => {
  return (
    <Fragment>
      <HeaderSkeleton />
      <div style={{ padding: 20 }}>
        <h3>
          <span style={{ color: '#DE350B', marginRight: 10 }}>
            {format('global-unhandled')}
          </span>
        </h3>
        <p>{format('reload-call-to-action')}</p>
        <p>{format('contact-us')}</p>
        <ErrorDetails caughtError={caughtError} />
      </div>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./app/common/components/GlobalErrorHandler/GlobalErrorHandler.tsx